import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { MobileNavbarComponent } from './mobile-navbar/mobile-navbar.component';
import { LogoComponent } from '@shared/logo/logo.component';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { Navigation, navigation } from '@shared/navigation/navigation.enum';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { LanguageSwitcherComponent } from '@shared/language-switcher/language-switcher.component';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'companyid-header',
    imports: [
        NgOptimizedImage,
        MobileNavbarComponent,
        LogoComponent,
        AssetPipe,
        ContentWrapperComponent,
        LanguageSwitcherComponent,
        RouterLink,
        RouterLinkActive,
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
    public headerNavigations: Navigation[] = navigation;
}
